import React, { Component } from 'react'
import { connect } from "react-redux";
import './Context.scss'
import { withTranslation } from 'react-i18next'
import { DynamicPathImage} from '@learningblocks/shared-components'


const lazyLoadImage = (path) => {
  return import(`${path}`)
    .then((module) => {
      return module.default
    })
    .catch((err) => {
      console.error("Failed to load image:", err);
      return null;
    });
};

class Context extends Component {

  getLangImg(imgBaseName, dirPath = './img/', fileExt = '.svg') {
    let fullPath
    if (this.props.supportedLangs.includes(this.props.lang)) {
      //if lang prop is supported - get lang img
      fullPath = dirPath + imgBaseName + "-" + this.props.lang + fileExt
    } else {
      //if lang prop not supported - return en img
      fullPath = dirPath + imgBaseName + "-en" + fileExt
    }
    return lazyLoadImage(fullPath);
  }

    render() {
        return (
          <div className="Context">
              <div>
                  <p className="description" >{this.props.t("Micropipettes are widely used in molecular biology labs to pipette small volumes of solutions in the microliter (μL) range. In this simulation, you will practice dispensing different volumes of liquid using a P20 micropipette.")}</p>
              </div>
              <div className="Section">
                <h3 className="SectionHeading" >{this.props.t("How to use a micropipette")}</h3>
                <div className="Group">
                  <div className="Table">
                    <div className="Item">
                      <span className="table-heading">{this.props.t("Adding a tip")}</span>
                      <div className="table-content">
                        <DynamicPathImage
                        // src={Pipette1}
                        src={this.getLangImg("Context1", "./img/translated-imgs/")}
                        alt={this.props.t('Tips are added by pressing the micropipette\'s barrel into the larger end of the tip.')} tabIndex={0} />
                      </div>
                    </div>
                    <div className="Item">
                      <span className="table-heading">{this.props.t("Setting volume")}</span>
                      <div className="table-content">
                        <DynamicPathImage 
                        // src={Pipette2}
                        src={this.getLangImg("Context2", "./img/translated-imgs/")}
                        alt={this.props.t('Volume is set by checking the vertical numbers in the display window. On a P20 pipette 2 0 0 is equal to 20 microliters. Conversion rates are different for other pipette sizes.')} tabIndex={0} />
                      </div>
                    </div>
                    <div className="Item">
                      <span className="table-heading">{this.props.t("Drawing up liquid")}</span>
                      <div className="table-content">
                        <DynamicPathImage 
                        // src={Pipette3}
                        src={this.getLangImg("Context3", "./img/translated-imgs/")}
                        alt={this.props.t('Liquid is drawn up by submerging the attached tip, and then pressing the plunger to the first stop.')} tabIndex={0} />
                      </div>
                    </div>
                    <div className="Item">
                      <span className="table-heading">{this.props.t("Expelling liquid")}</span>
                      <div className="table-content">
                        <DynamicPathImage 
                        // src={Pipette4}
                        src={this.getLangImg("Context4", "./img/translated-imgs/")}
                        alt={this.props.t('​​​​​​Liquid is expelled by pressing the plunger to the second stop.')} tabIndex={0} />
                      </div>
                    </div>
                  </div>
                  {/* <div>
                      <p className="description" tabIndex={0}>If you haven't used a micropipette before, or would like a refresher, please watch the video below. When you're ready, click the Next button to continue.</p>
                  </div> */}
                </div>
                {/* <div>
                  <div tabIndex={0} className="videoWrapper">
                    <iframe
                      title="Micropipetting video"
                      tabIndex={0}
                      tabIndex={this.props.tab}
                      src="https://www.youtube.com/embed/QnaCMvDcel4"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                      width="640"
                      height="360"
                      frameBorder="0"></iframe>
                  </div>
                </div> */}
              </div>
          </div>

        );
    }
}

const mapStateToProps = state => {
  return {
    lang: state.scene.lang,
    supportedLangs: state.scene.supportedLangs,
  };
};

export default connect(
  mapStateToProps, {}
)(withTranslation()(Context));
